"use client";

import { SkeletonBlock, SkeletonLine, SkeletonPill, SkeletonStack, WidgetCard } from "@health/ui";

/**
 * Loading skeleton mirroring ProductCard — image area on top, then a card
 * body with tagline, title, description, price row, three highlight rows,
 * and a full-width CTA.
 *
 * Lives in its own file so {@link WidgetLoadingRegistry} can import it
 * without pulling in the lazy-loaded {@link ProductCard} chunk.
 */
export function ProductCardSkeleton() {
  return (
    <WidgetCard $padding="none" className="overflow-hidden w-full">
      <SkeletonBlock $h="lg" $radius="sm" className="rounded-none" />
      <div className="p-6">
        <SkeletonStack>
          <SkeletonLine $size="caption" $width="xs" />
          <SkeletonLine $size="title" $width="md" />
          <SkeletonLine $size="text" $width="lg" />
          <div className="flex items-baseline gap-2 pt-1">
            <SkeletonLine $size="title" $width="xs" className="h-7" />
            <SkeletonLine $size="caption" $width="sm" />
          </div>
          {[0, 1, 2].map((i) => (
            <div key={i} className="flex items-center gap-2">
              <SkeletonLine $size="caption" $width="xs" className="w-3.5 h-3.5 rounded-full" />
              <SkeletonLine $size="text" $width={i === 0 ? "lg" : i === 1 ? "md" : "sm"} />
            </div>
          ))}
          <SkeletonPill $size="lg" $width="xl" className="w-full" />
        </SkeletonStack>
      </div>
    </WidgetCard>
  );
}
